<template>
  <div class="space-y-8">
    <div>
      <AccountAddAction :contact-id="contactId" @account-added="onAccountAdded" />
    </div>
    <div>
      <AccountList ref="accountList" :contact-id="contactId" @change="$emit('refresh')" />
    </div>
  </div>
</template>

<script>
import AccountAddAction from './AccountAddAction.vue';
import AccountList from './AccountList.vue';

export default {
  components: { AccountList, AccountAddAction },
  props: {
    contactId: {
      type: String,
      required: true,
    },
  },
  methods: {
    onAccountAdded() {
      this.$refs.accountList.refreshList();
    },
  },
};
</script>
